
  import Events from '@/events/Events';
  import JobBoxAlert from '@/components/JobBoxAlert';
  import JobBoxWithTypesense from '@/mixins/JobBoxWithTypesense';

  export default {
    name: 'JobBoxOpportunities',
    components: {
      JobBoxAlert,
    },
    mixins: [JobBoxWithTypesense],
    props: {
      numJobPostings: {
        type: Number,
        required: false,
        default: 5,
      },
      sectionFilterParams: {
        type: String,
        required: false,
        default: '',
      },
      icons: {
        type: Boolean,
        required: false,
        default: true,
      },
      jobBoxType: {
        type: String,
        required: false,
        default: 'Compact',
      },
      showJobAlertBox: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      return {
        loading: true,
        jobPostings: [],
        jobAlertSearchRequestUrl: '',
      };
    },
    fetch() {
      this.jobAlertSearchRequestUrl =
        this.sectionFilterParams +
        '&order[order_number]=desc&itemsPerPage=16&page=1&additionalFilters=opportunities';
      this.jobAlertSearchRequestUrl = this.jobAlertSearchRequestUrl.replace(
        /&pagination=false/g,
        ''
      );
      if (!this.jobAlertSearchRequestUrl.includes('isPublished')) {
        this.jobAlertSearchRequestUrl += '&isPublished=1';
      }
    },
    mounted() {
      this.getOpportunitiesJobPostings().catch((e) => {
        this.jobPostings = [];
        this.loading = false;

        throw e;
      });
    },
    created() {
      this.filterConfig.sectionFilterParams =
        this.sectionFilterParams === ''
          ? new URLSearchParams()
          : new URLSearchParams(this.sectionFilterParams);
      this.filterConfig.numJobPostings = this.numJobPostings * 5;
      this.filterConfig.shuffleAndSlice = this.numJobPostings;
    },
    methods: {
      async getOpportunitiesJobPostings() {
        // Jobs mit Opportunities-Filter ermitteln
        this.filterConfig.additionalFilterParams.set(
          'additionalFilters',
          'opportunities'
        );

        this.filterConfig.filteredTopTeaser = true;
        this.filterConfig.filteredInstantTeaser = true;
        this.filterConfig.filteredHomepageTeaser = true;

        await this.fetchJobPostings();

        // Auffüllen der Jobs mit Jobs mit Kriterien aus Filter-Params der Section die keine Top-Jobs sind
        if (this.mergedJobPostings.length < this.numJobPostings) {
          // Keine TopJobs, keine SpecialOffers
          this.filterConfig.additionalFilterParams = new URLSearchParams();

          // Hier sollen nur die normalen Jobs berücksichtigt werden und nicht mehr die TopTeaser/InstantTeaser
          // weil diese sonst mehrfach einfließen
          this.filterConfig.getTopTeaserJobPostings = false;
          this.filterConfig.getInstantTeaserJobPostings = false;
          this.filterConfig.getHomepageTeaserJobPostings = false;

          await this.fetchJobPostings();
        }

        this.jobPostings = this.mergedJobPostings;

        const items = this.jobPostings.map((item, key) => ({
          id: item.id,
          position: key + 1,
        }));

        this.$emitWithClientData(Events.JobBoxViewed, {
          boxType: 'Opportunities',
          items,
        });
      },
    },
  };
